module.exports = __webpack_public_path__ + "img/desc.60d9bcd6.png";